import { useEffect, useState } from "react";
import getFirebaseInstance from "./firebase";
import loadFirebaseDependencies from "./loadFirebaseDependencies";

function useAuth() {
  const [user, setUser] = useState(null);
  const [firebase, setFirebase] = useState(null);
  const [loading, setLoading] = useState(true);
  const [serverTime, setServerTime] = useState(null);
  useEffect(() => {}, [user]);
  useEffect(() => {
    let unsubscribe;

    loadFirebaseDependencies.then((app) => {
      const firebaseInstance = getFirebaseInstance(app);
      setFirebase(firebaseInstance);
      firebaseInstance.getServerTime().then((result) => {
        setServerTime(result.data.time);
      });
      unsubscribe = firebaseInstance.auth.onIdTokenChanged((userResult) => {
        //console.log("detected token change");
        if (userResult) {
          firebaseInstance.db
            .collection("users")
            .doc(userResult.uid)
            .onSnapshot((doc) => {
              // Check if document exists and has data
              if (doc.exists && doc.data()) {
                const userData = doc.data();
                setUser({
                  ...userResult._delegate,
                  email: userData.email || userResult.email,
                  firstname: userData.firstname,
                  lastname: userData.lastname,
                  expiryTime: userData.expiryTime,
                  latestPlan: userData.latestPlan,
                  stripeId: userData.stripeId,
                  shortId: userData.shortId,
                  university: userData.university
                });
              } else {
                // Document doesn't exist yet (user just registered, profile being created)
                // Set basic user info from auth, profile will be added when document is created
                setUser({
                  ...userResult._delegate,
                  email: userResult.email,
                });
              }
              setLoading(false);
            });
        } else {
          setUser(null);
          setLoading(false);
        }
      });
    });

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);

  return { user, firebase, loading, serverTime };
}

export default useAuth;
